<template>
  <section>
    <!-- Listing Header -->
    <!-- <storage-header :isOrg="isOrg" @search="search" @add="addBlob" /> -->
    <!-- Listing -->
    <div class="custom-wrapper">
      <z-table
        :value="blobs"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <td class="z-column-60-center">
            <a href="#" v-if="isImage(props.row)" @click="viewBlob(props.row)"
              >view</a
            >
            <a v-else :href="props.row.Url" target="_blank">download</a>
          </td>
          <td style="word-break: break-all">
            {{ props.row.Name }}
          </td>
          <td>{{ props.row.id }}</td>
          <td class="z-column-60-center">
            <a href="#" @click="remove(props.row)">remove</a>
          </td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <storage-image-dialog
      id="storage-image-modal"
      :show="actionBlob"
      @close="closeModal"
    />
    <confirm-remove
      :show="actionConfirmRemove"
      :confirmTitle="confirmTitleRemove"
      :confirmAction="confirmActionRemove"
      :confirmQuestion="confirmQuestionRemove"
      @closing="closeModal"
      @proceed="performRemove"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
import StorageHeader from '@/Components/AzureStorage/storage-header'
import StorageImageDialog from '@/Components/AzureStorage/forms/storage-image-dialog'
export default {
  name: 'storage-listing',
  components: {
    ZTable,
    ConfirmRemove,
    StorageHeader,
    StorageImageDialog,
  },
  props: {
    isOrg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      actionBlob: null,
      isLoading: false,
      itemName: null,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove: 'Are you sure you wish to remove ',
      actionConfirmRemove: null,
    }
  },
  async mounted() {
    this.isLoading = false
    this.itemName = null
    await this.loadBlobs()
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('azurestorage', ['blobs', 'blob', 'pager']),
    ...mapGetters('organizations', ['organization']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'Name', label: 'Name', sortable: false },
        {
          field: 'id',
          label: 'Id',
          sortable: false,
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
  },
  methods: {
    ...mapActions('azurestorage', [
      'getBlobs',
      'getBlob',
      'resetBlob',
      'setPager',
      'removeBlob',
    ]),
    async loadBlobs() {
      try {
        this.isLoading = true
        await this.getBlobs({
          orgId: this.organization.id,
        })
        window.app.$forceUpdate()
        this.isLoading = false
      } catch (e) {
        console.log('Error', e)
      }
    },
    isImage(row) {
      let is = false
      if (row) {
        if (row.Name) {
          let elements = row.Name.split('.')
          if (elements.length > 1) {
            switch (elements[1].toLowerCase()) {
              case 'jpg':
                is = true
                break
              case 'jpeg':
                is = true
                break
              case 'png':
                is = true
                break
              case 'bmp':
                is = true
                break
            }
          }
        }
      }
      return is
    },
    formatClosed(closed) {
      return closed ? 'Y' : ''
    },
    formatDate(date) {
      return moment(new Date(date)).format('MM/DD/YYYY')
    },
    closeModal() {
      this.actionConfirmRemove = null
      this.actionBlob = null
    },
    savedBlob() {
      this.actionBlob = null
      this.loadBlobs()
    },
    async addBlob() {
      let data = {
        id: this.profile.id,
        orgCode: this.isOrg ? this.organization.orgCode : null,
      }
      this.resetBlob(data)
      this.actionBlob = {
        isAdd: true,
        data: null,
      }
    },
    async viewBlob(row) {
      this.actionBlob = {
        url: row.Url,
        name: row.Name,
      }
    },
    remove(data) {
      this.itemName = data.Name
      this.confirmQuestionRemove = `Are you sure you wish to remove ${data.Name}?`
      this.actionConfirmRemove = true
    },
    async performRemove() {
      this.actionConfirmRemove = null
      // Perform Removal
      let data = {
        orgId: this.organization.id,
        name: this.itemName,
      }
      await this.removeBlob(data)
      this.loadBlobs()
      this.itemName = null
    },
  },
}
</script>
<style lang='scss'>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  width: 100%;
}
.custom-add {
  position: absolute;
  top: 9px;
  left: 8px;
}
</style>
